












import Vue from 'vue';
import Component from 'vue-class-component';
import UserInfo from './UserInfo.vue';
import Search from './Search.vue';
import EventBus from '@/services/eventBus';

@Component({
    components: {
        UserInfo,
        Search,
    },
})
export default class TopMenu extends Vue {
    isMoviesLoading = false;

    get userId() {
        const result = this.$store.getters.userId;

        return result;
    }

    mounted() {
        EventBus.$on('setMoviesLoading', (value: any) => {
            this.isMoviesLoading = value;
        });
    }
}
